import React from 'react';
import { useNavigate } from 'react-router-dom';
import ProfilePage from './ProfilePage';

const ProfilePageWrapper: React.FC = () => {
  const navigate = useNavigate();
  
  return <ProfilePage navigate={navigate} />;
};

export default ProfilePageWrapper;
